// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Color = require("../Chip.Model.Color/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var initInventory = {
    red: 0,
    cyan: 0,
    yellow: 0,
    green: false,
    skiSkates: false,
    suctionBoots: false,
    fireBoots: false,
    flippers: false
};
var has = function (item) {
    return function (inv) {
        if (item instanceof Chip_Model_Item.SkiSkates) {
            return inv.skiSkates;
        };
        if (item instanceof Chip_Model_Item.SuctionBoots) {
            return inv.suctionBoots;
        };
        if (item instanceof Chip_Model_Item.FireBoots) {
            return inv.fireBoots;
        };
        if (item instanceof Chip_Model_Item.Flippers) {
            return inv.flippers;
        };
        if (item instanceof Chip_Model_Item.Key) {
            if (item.value0 instanceof Chip_Model_Color.Red) {
                return inv.red > 0;
            };
            if (item.value0 instanceof Chip_Model_Color.Cyan) {
                return inv.cyan > 0;
            };
            if (item.value0 instanceof Chip_Model_Color.Yellow) {
                return inv.yellow > 0;
            };
            if (item.value0 instanceof Chip_Model_Color.Green) {
                return inv.green;
            };
            throw new Error("Failed pattern match at Chip.Model.Inventory (line 44, column 16 - line 48, column 25): " + [ item.value0.constructor.name ]);
        };
        throw new Error("Failed pattern match at Chip.Model.Inventory (line 39, column 16 - line 48, column 25): " + [ item.constructor.name ]);
    };
};
module.exports = {
    has: has,
    initInventory: initInventory
};
